import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const CartIcon = ({ color, className }: any) => {
  return (
    <SvgIcon style={styles.icon} className={className}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 2.25C2.58579 2.25 2.25 2.58579 2.25 3C2.25 3.41421 2.58579 3.75 3 3.75H4.92096L6.4206 14.2475C6.54376 15.1096 7.28212 15.75 8.15301 15.75H18.4641C19.2997 15.75 20.0187 15.1593 20.1809 14.3396L21.4996 7.67291C21.7136 6.59105 20.8856 5.58333 19.7828 5.58333H6.69809L6.31389 2.89393C6.26111 2.52445 5.94467 2.25 5.57143 2.25H3ZM7.90552 14.0354L6.91238 7.08333H19.7828C19.9404 7.08333 20.0586 7.22729 20.0281 7.38184L18.7094 14.0485C18.6862 14.1656 18.5835 14.25 18.4641 14.25H8.15301C8.0286 14.25 7.92312 14.1585 7.90552 14.0354ZM9 19.75C8.86193 19.75 8.75 19.8619 8.75 20C8.75 20.1381 8.86193 20.25 9 20.25C9.13807 20.25 9.25 20.1381 9.25 20C9.25 19.8619 9.13807 19.75 9 19.75ZM7.25 20C7.25 19.0335 8.0335 18.25 9 18.25C9.9665 18.25 10.75 19.0335 10.75 20C10.75 20.9665 9.9665 21.75 9 21.75C8.0335 21.75 7.25 20.9665 7.25 20ZM17 19.75C16.8619 19.75 16.75 19.8619 16.75 20C16.75 20.1381 16.8619 20.25 17 20.25C17.1381 20.25 17.25 20.1381 17.25 20C17.25 19.8619 17.1381 19.75 17 19.75ZM15.25 20C15.25 19.0335 16.0335 18.25 17 18.25C17.9665 18.25 18.75 19.0335 18.75 20C18.75 20.9665 17.9665 21.75 17 21.75C16.0335 21.75 15.25 20.9665 15.25 20Z"
          fill={color || "#333333"}
        />
      </svg>
    </SvgIcon>
  );
};

export default CartIcon;
